import { i18n } from "i18n/i18n"

export function getColorTranslation(color: string): string {
  switch (color) {
    case 'Бежевый':
      return i18n('ColorBeige')
    case 'Белый':
      return i18n('ColorWhite')
    case 'Бесцветный':
      return i18n('ColorColorless')
    case 'Бирюзовый':
      return i18n('ColorTurquoise')
    case 'Бордовый':
      return i18n('ColorBurgundy')
    case 'Бронзовый':
      return i18n('ColorBronze')
    case 'Голубой':
      return i18n('ColorLightBlue')
    case 'Желтый':
    case 'Жёлтый':
      return i18n('ColorYellow')
    case 'Зелёный':
    case 'Зеленый':
    case 'Зелëный':
      return i18n('ColorGreen')
    case 'Золотой':
      return i18n('ColorGolden')
    case 'Коричневый':
    case 'Коричевый':
      return i18n('ColorBrown')
    case 'Красный':
      return i18n('ColorRed')
    case 'Кремовый':
      return i18n('ColorCream')
    case 'Леопардовый':
      return i18n('ColorLeopard')
    case 'Малиновый':
      return i18n('ColorCrimson')
    case 'Медный':
      return i18n('ColorCopper')
    case 'Оранжевый':
      return i18n('ColorOrange')
    case 'Прозрачный':
      return i18n('ColorTransparent')
    case 'Разноцветный':
      return i18n('ColorMulticolor')
    case 'Розовый':
      return i18n('ColorPink')
    case 'Салатовый':
      return i18n('ColorLightGreen')
    case 'Светло-бежевый':
      return i18n('ColorLightBeige')
    case 'Светло-розовый':
      return i18n('ColorLightPink')
    case 'Серебряный':
      return i18n('ColorSilver')
    case 'Серый':
      return i18n('ColorGray')
    case 'Синий':
      return i18n('ColorBlue')
    case 'Cиреневый':
    case 'Сиренев':
    case 'Сиреневый':
      return i18n('ColorLilac')
    case 'Темно-серый':
      return i18n('ColorDarkGray')
    case 'Фиолетовый':
      return i18n('ColorPurple')
    case 'Хаки':
      return i18n('ColorKhaki')
    case 'Чёрно-белый':
      return i18n('ColorBlackAndWhite')
    case 'Чёрный':
      return i18n('ColorBlack')
    default:
      return color
  }
}

export function getCategoryTranslations(category: string): string {
  switch (category) {
    // BOTTOMS
    case 'Юбки':
      return i18n('CategorySkirts')
    case 'Брюки':
      return i18n('CategoryTrousers')
    case 'Шорты':
      return i18n('CategoryShorts')
    case 'Джинсы':
      return i18n('CategoryJeans')
    case 'Кюлоты':
      return i18n('CategoryCulottes')
    case 'Легинсы':
      return i18n('CategoryLeggings')
    // TOPS
    case 'Блузы':
      return i18n('CategoryBlouses')
    case 'Жакеты':
      return i18n('CategoryJackets')
    case 'Кардиганы':
    case 'Джемперы':
      return i18n('CategoryCardigans')
    case 'Накидки':
    case 'Кейпы и накидки':
      return i18n('CategoryCapes')
    case 'Топы':
      return i18n('CategoryTops')
    case 'Боди':
      return i18n('CategoryBodysuits')
    case 'Толстовки':
      return i18n('CategoryHoodies')
    case 'Водолазки':
      return i18n('CategoryTurtlenecks')
    case 'Жакеты и костюмы':
      return i18n('CategoryJacketsAndSuits')
    case 'Жилеты':
      return i18n('CategoryVests')
    case 'Поло':
      return i18n('CategoryPolo')
    case 'Трикотаж':
      return i18n('CategoryKnitwear')
    case 'Туники':
      return i18n('CategoryTunics')
    case 'Футболки и топы':
      return i18n('CategoryTShirtsAndTops')
    case 'Майки':
      return i18n('CategoryAShirts')
    case 'Футболки':
      return i18n('CategoryTShirts')
    case 'Пиджаки':
      return i18n('CategoryJacketsMen')
    case 'Рубашки':
      return i18n('CategoryShirts')
    case 'Свитеры':
      return i18n('CategorySweaters')
    case 'Свитшоты':
      return i18n('CategorySweatshirts')
    default:
      return category
  }
}

export function getCategoryGroupTranslation(group: string): string {
  // FEMALE
  switch (group) {
    case 'Женское > Винтаж > Одежда':
      return i18n('FemaleVintage')
    case 'Женское > Одежда > Бельё':
      return i18n('FemaleLingerie')
    case 'Женское > Одежда':
      return i18n('FemaleClothing')
    case 'Женское > Одежда > Верхняя одежда':
      return i18n('FemaleOuterwear')
    case 'Женское > Одежда > Спорт':
      return i18n('FemaleSport')
    // MALE
    case 'Мужское > Одежда > Бельё и домашняя одежда':
      return i18n('MaleUnderwear')
    case 'Мужское > Одежда > Верхняя одежда':
      return i18n('MaleOuterwear')
    case 'Мужское > Одежда':
      return i18n('MaleClothing')
    default:
      return group
  }
}
